import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";

export default function ScreenDonSection({context, campagneData}) {
    const [loading, setLoading] = useState(true)
    const [dons, setDons] = useState([])

    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2})

    const partnerMontant = campagneData?.partnerMontant || 1
    const screenOptions = campagneData?.screenOptions || {}

    const getDisplayName = (campagneExtraData = {}) => {
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons = async () => {
        let url = "/campagne/donors/" + campagneData.id
        const res = await ApiService.get(url)
        let _dons = res.data

        if (screenOptions.minMontant) {
            _dons = _dons.filter(i => i.montant >= screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)

    if (loading) {
        return null
    }

    return (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding: "0 5vw"}}>
            <div style={{
                overflow: "visible",
                width: "90%",
                height: "18vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row-reverse",
                gap: "3vw"
            }}>
                {dons.map((d, index) => {
                    let className = "screen-don-card"
                    className += index < 4 ? " screenDonFadeIn" : " screenDonFadeOut"

                    return (
                        <div key={d.id} className={className}>
                            <span className="brunoy2-card-amount" style={{
                                color: "#5C0F1A",
                                fontSize: "4.5vh",
                                fontWeight: 700,
                                textAlign: "center",
                                lineHeight: 1.1
                            }}>
                                {formater.format(d.montant / partnerMontant)} m²
                            </span>
                            <span className="brunoy2-card-name" style={{
                                color: "#5C0F1A",
                                fontSize: "2.8vh",
                                fontWeight: 200,
                                textAlign: "center",
                                lineHeight: 1.2
                            }}>
                                {getDisplayName(d.campagneExtraData)}
                            </span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
